import { render, staticRenderFns } from "./VBackground.vue?vue&type=template&id=49a9da19&scoped=true"
import script from "./VBackground.vue?vue&type=script&lang=js"
export * from "./VBackground.vue?vue&type=script&lang=js"
import style0 from "./VBackground.vue?vue&type=style&index=0&id=49a9da19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a9da19",
  null
  
)

export default component.exports